import { toast } from 'react-toastify';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { withRouter } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import Isvg from 'react-inlinesvg';
import Dropzone from 'react-dropzone';
import Modal from 'react-modal';
import AvatarEditor from 'react-avatar-editor';
import { Tooltip } from 'react-tippy';

import { Theme } from '../../config/theme';
import {
  mapStateToProps,
  mapDispatchToProps,
  availability,
  livingSituations,
  regularity,
} from '../../utils';

import { updateUserRemote } from '../../actions/user';
import { updateAppState } from '../../actions/applicationState';


import ErrorContainer from '../../components/ErrorContainer';
import ContentContainer from '../../components/ContentContainer';
import HorizontalRule from '../../components/HorizontalRule';
import TextField from '../../components/TextField';
import SimpleSelect from '../../components/SimpleSelect';
import Select from '../../components/Select';
import CheckboxField from '../../components/CheckboxField';
import CheckButton from '../../components/CheckButton';

const EDITICON_ASSET = require('./EditIcon.svg');
const UPLOAD_ASSET = require('./Upload.svg');
const ROTATE_ICON = require('./rotate.png');
const TOOLTIP_ASSET = require('./tooltip.svg');

class EditProfile extends Component {
  constructor(props) {
    super(props);
    this.selectHandler = this.handleSelect.bind(this);
    this.setValue = this.updateTextField.bind(this);
    this.acceptFiles = this.handleFileDrop.bind(this);
    this.editAvator = this.handleAvatarFileDrop.bind(this);
    this.handleRotation = this.handleImageRotation.bind(this);
    this.avatarSaveImage = this.handleAvatarSaveImage.bind(this);
    this.clearImage = this.handleClearImage.bind(this);
    this.saveDraft = this.handleSave.bind(this, false);
    this.savePublish = this.handleSave.bind(this, true);
    this.editorRef = this.setEditorRef.bind(this);
    this.handleClose = this.avatarEditorModalHandler.bind(this);

    this.toast = (message) => {
      toast.info(message, {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
      });
    };


    this.state = {
      active: false,
      completed: false,

      display_name: props.user.display_name,
      availability: props.user.availability,
      living_situation: props.user.living_situation,
      regularity: props.user.regularity,
      bio: props.user.bio,
      pet_insurance: props.user.pet_insurance,
      police_checked: props.user.police_checked,
      suburb: props.user.suburb ? props.user.suburb.id : null,

      interests: props.user.interests.map(interest => interest.id),
      needs: props.user.needs.map(need => need.id),

      profile_photo_updated: false,
      profile_photo_deleted: false,
      profile_photo: props.user.profile_photo,
      profile_photo_size: props.user.profile_photo_size,
      profile_photo_file: props.user.profile_photo_file,
      avatarPhoto: [],
      avatarPhotoRotation: null,

      errors: {
        nickname: false,
        photos: false,
        profile_photo_error: false,
        suburb: false,
      },
    };

    this.availability = availability;
    this.living_situations = livingSituations;
    this.regularity = regularity;
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        active: true,
      });
    }, 100);

    setTimeout(() => {
      this.props.dispatch(updateAppState({
        loading: false,
      }));
    }, 750);
  }

  setEditorRef(editor) {
    this.editor = editor;
  }

  getFieldsToStore() {
    const fields = {
      display_name: this.state.display_name,
      availability: this.state.availability,
      living_situation: this.state.living_situation,
      regularity: this.state.regularity,
      bio: this.state.bio,
      pet_insurance: this.state.pet_insurance,
      police_checked: this.state.police_checked,
      suburb: this.state.suburb && this.state.suburb.value > 0 ? this.state.suburb.value : null,

      interests: this.state.interests,
      needs: this.state.needs,

      profile_photo_deleted: this.state.profile_photo_deleted,
    };

    if (this.state.profile_photo_updated) {
      fields.profile_photo = this.state.profile_photo;
      fields.profile_photo_size = this.state.profile_photo_size;
      fields.profile_photo_file = this.state.profile_photo_file;
    }

    return fields;
  }

  avatarEditorModalHandler() {
    this.setState({
      avatar_editor_modal_open: !this.state.avatar_editor_modal_open,
    });
  }

  handleSelect(name, id, value) {
    if (value) {
      this.addKey(name, id);
    } else {
      this.removeKey(name, id);
    }
  }

  updateTextField(key, value) {
    const updatedState = {
      [key]: value,
    };
    this.setState(updatedState);
  }

  // Add a unique key to array in state
  addKey(name, key) {
    const state = this.state;
    const inArray = state[name].find(obj => obj === key);

    // If the item is not already in the array, add it. Otherwise return state
    this.setState({
      [name]: !inArray ? state[name].concat([key]) : state,
    });
  }

  // Remove key from an array in state
  removeKey(name, key) {
    const state = this.state;

    this.setState({
      [name]: state[name].filter(obj => obj !== key),
    });
  }

  handleClearImage() {
    this.setState({
      profile_photo_updated: false,
      profile_photo_deleted: true,
      profile_photo: null,
    });
  }

  handleFileDrop(acceptedFiles, rejectedFiles) {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const fileAsDataURL = reader.result;

        this.setState({
          profile_photo_updated: true,
          profile_photo_deleted: false,
          profile_photo: fileAsDataURL,
          profile_photo_size: file.size,
          profile_photo_file: file.name,
        });
      };
    });

    if (rejectedFiles && rejectedFiles.length) {
      this.setState({
        errors: Object.assign({}, this.state.errors, {
          photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.',
        }),
      });
    } else {
      this.setState({
        errors: Object.assign({}, this.state.errors, {
          photos: false,
        }),
      });
    }
  }

  handleAvatarFileDrop(acceptedFiles, rejectedFiles) {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const fileAsDataURL = reader.result;

        if (!this.state.avatarPhoto.length) {
          this.setState({
            avatar_editor_modal_open: true,
            profile_photo_deleted: false,
            avatarPhoto: {
              id: null,
              remote: false,
              src: fileAsDataURL,
              size: file.size,
              file_name: file.name,
            },
          });
        }
      };
    });

    if (rejectedFiles && rejectedFiles.length) {
      this.setState({
        errors: Object.assign({}, this.state.errors, {
          photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.',
        }),
      });
    } else {
      this.setState({
        errors: Object.assign({}, this.state.errors, {
          photos: false,
        }),
      });
    }
  }

  handleImageRotation() {
    const angle = (this.state.avatarPhotoRotation + 90) % 360;
    this.setState({
      avatarPhotoRotation: angle,
    });
  }

  handleAvatarSaveImage() {
    const avatarPhoto = this.state.avatarPhoto;
    const canvasImage = this.editor.props;
    const newImage = this.editor.getImage();
    this.setState({
      avatar_editor_modal_open: false,
      profile_photo_updated: true,
      profile_photo_deleted: false,
      profile_photo: newImage.toDataURL('image/jpeg', 0.8),
      profile_photo_size: avatarPhoto.size,
      profile_photo_file: avatarPhoto.name,
      profile_photo_rotation: canvasImage.rotate,
    });
  }

  fileSize(b) {
    let u = 0;
    const s = 1024;

    while (b >= s || -b >= s) {
      b /= s; //eslint-disable-line
      u += 1;
    }
    return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
  }

  validateForm() {
    const errors = {};

    if (!this.state.profile_photo || !this.state.profile_photo.length) {
      errors.profile_photo_error = 'To save your profile as complete, please upload your photo.';
    } else {
      errors.profile_photo_error = null;
    }

    if (!this.state.display_name) {
      errors.nickname = 'Please enter your Name / Nickname';
    } else {
      errors.nickname = null;
    }

    let formErrors = false;

    for (const key in errors) {   //eslint-disable-line
      if (errors[key] !== null) {
        formErrors = true;
      }
    }

    if (formErrors) {
      this.setState({
        errors,
      });

      return false;
    }

    return true;
  }

  handleSave(published) {
    if (published) {
      // If the user is trying to publish, the form must validate.
      // The user can save an incomplete form only if it's a draft
      if (!this.validateForm()) {
        return false;
      }
    }

    this.props.dispatch(updateAppState({
      loading: true,
    })).then(() => (
      this.props.dispatch(updateUserRemote(
        Object.assign({}, this.getFieldsToStore(), {
          published,
        }),
        this.props.user.access_token,
      )).then(() => {
        this.toast((published) ?
          'Your profile is now saved as \'complete\'.' :
          'Your profile is now saved as \'draft\'.');
        this.props.dispatch(updateAppState({
          loading: false,
        }));

        this.props.history.push('/profile/' + this.props.user.id);
      }, (err) => {
        console.log(err); // eslint-disable-line no-console
        this.props.dispatch(updateAppState({
          loading: false,
        }));
      })
    ), (err) => {
      console.log(err); // eslint-disable-line no-console
      this.props.dispatch(updateAppState({
        loading: false,
      }));
    });

    return true;
  }

  render() {
    const selectedNeeds = this.state.needs;
    const selectedInterests = this.state.interests;

    return (
      <div className={css(
        styles.container,
        this.state.active ? styles.container_active : null,
        this.state.completed ? styles.container_completed : null,
      )}>
        <ContentContainer>
          <Isvg
            cacheGetRequests
            src={EDITICON_ASSET}
            className={css(styles.icon)}
          />
          <h1 className={css(styles.heading)}>
            Hi <span className={css(styles.highlight)}>{this.props.user.display_name}</span>,
            <br />
            {'Let\'s'} edit your profile.
          </h1>
          <div className={css(styles.main)}>
            <div className={css(styles.form)}>
              <HorizontalRule pin />

              <h2 className={css(styles.sub_heading)}>Personal information</h2>
              <TextField
                id="display_name"
                name="display_name"
                label="Name/Nickname"
                required
                value={this.state.display_name}
                handler={this.setValue}
                error={this.state.errors.nickname}
              />
              <div className={css(styles.select_parent_container)}>
                <div className={css(styles.select_container)}>
                  <Select
                    id="suburb"
                    name="suburb"
                    options={this.props.appdata.suburb.map(suburb => ({
                      value: suburb.id,
                      label: `${suburb.title}, ${suburb.district.title}`,
                    }))}
                    label="Suburb"
                    required
                    value={this.state.suburb}
                    type="location"
                    handler={this.setValue}
                    style={styles.select_style}
                  />
                </div>
              </div>
              {this.props.user.subscription === 'Borrower' ?
                <SimpleSelect
                  id="availability"
                  name="availability"
                  options={this.availability}
                  label="Availability"
                  required
                  value={this.state.availability}
                  handler={this.setValue}
                />
                : null}
              {this.props.user.subscription === 'Borrower' ?
                <SimpleSelect
                  id="living_situation"
                  name="living_situation"
                  options={this.living_situations}
                  label="Living situation"
                  value={this.state.living_situation}
                  handler={this.setValue}
                  required
                />
                : null}
              {this.props.user.subscription === 'Borrower' ?
                <SimpleSelect
                  id="regularity"
                  name="regularity"
                  options={this.regularity}
                  label="Regularity desired"
                  required
                  value={this.state.regularity}
                  handler={this.setValue}
                />
                : null}
              <TextField
                id="bio"
                name="bio"
                label="About me"
                textArea
                fullWidth
                showRemaining
                limit={1000}
                height={85}
                required
                value={this.state.bio}
                handler={this.setValue}
              />

              <div className={css(styles.checkboxes)}>
                {
                  this.props.user.subscription === 'Owner' ? (
                    <CheckboxField
                      id="pet_insurance"
                      name="pet_insurance"
                      label="I have pet insurance"
                      tooltip="Do you have pet insurance secured for your pooch?"
                      required
                      value={this.state.pet_insurance}
                      handler={this.setValue}
                    />
                  ) : false
                }
                <CheckboxField
                  id="police_checked"
                  name="police_checked"
                  label="I have been police checked"
                  tooltip="Do you hold a Police Check? You can indicate this
                  to increase your personal trust profile."
                  required
                  value={this.state.police_checked}
                  handler={this.setValue}
                />
              </div>

              {this.props.user.subscription === 'Borrower' ?
                <div>
                  <HorizontalRule pin />
                  <h2 className={css(styles.sub_heading)}>
                    {'I\'m good with...'}
                  </h2>
                  <p className={css(styles.paragraph)}>
                    Select as many that are relevant to you.
                  </p>
                  <div className={css(styles.check_buttons)}>
                    {
                      this.props.appdata.need.map(need => (
                        <CheckButton
                          id={need.id}
                          name="needs"
                          label={need.title}
                          onSelect={this.selectHandler}
                          selected={
                            selectedNeeds.find(selectedNeed =>
                              (need.id === selectedNeed ||
                                need.id === selectedNeed.id),
                            )
                          } />
                      ))
                    }
                  </div>
                  <br />

                  <HorizontalRule pin />
                  <h2 className={css(styles.sub_heading)}>
                    {'I\'m interested in...'}
                  </h2>
                  <p className={css(styles.paragraph)}>
                    Select as many that are relevant to you.
                  </p>
                  <div className={css(styles.check_buttons)}>
                    {
                      this.props.appdata.interest.map(interest => (
                        <CheckButton
                          id={interest.id}
                          name="interests"
                          label={interest.title}
                          onSelect={this.selectHandler}
                          selected={
                            selectedInterests.find(selectedInterest =>
                              (interest.id === selectedInterest ||
                                interest.id === selectedInterest.id))
                          } />
                      ))
                    }
                  </div>
                </div>
                : null}

              <HorizontalRule pin />

              <h2 className={css(styles.sub_heading)}>Upload a profile photo</h2>
              <p className={css(styles.paragraph)}>
                You can add one photo of yourself, each image has to be below 2MB, and be
                in .jpg or .png format. For security purposes, the image must clearly be a
                picture of you (not your dog)!
              </p>
              <div className={css(styles.avatarEditor)}>
                {
                  this.state.avatarPhoto.src ? (
                    <Modal
                      isOpen={this.state.avatar_editor_modal_open}
                      className={css(styles.modal_container)}
                      onRequestClose={this.handleClose}
                      style={{
                        overlay: {
                          backgroundColor: 'rgba(0,0,0,0.67)',
                          zIndex: 101,
                          display: 'flex',
                        },
                      }}
                      contentLabel="Photo Editor"
                    >
                      <div className={css(styles.modal_wrapper)}>
                        <div className={css(styles.header)}>
                          <h2 className={css(styles.modal_title)}>Photo Editor</h2>
                        </div>
                        <div className={css(styles.body)}>
                          <div className={css(styles.avatarCanvas)}>
                            <AvatarEditor
                              ref={this.editorRef}
                              image={this.state.avatarPhoto.src}
                              width={250}
                              height={250}
                              color={[255, 255, 255, 0.6]} // RGBA
                              scale={1.2}
                              rotate={this.state.avatarPhotoRotation}
                            />
                          </div>
                        </div>
                        <div className={css(styles.actions_container)}>
                          {
                            this.state.avatarPhoto.src ? (
                              <div
                                role="button"
                                tabIndex={0}
                                onClick={this.handleRotation}>
                                <img
                                  className={css(styles.rotate_icon)}
                                  src={ROTATE_ICON}
                                  alt="rotate"
                                />
                              </div>
                            ) : false
                          }
                          {
                            this.state.avatarPhoto.src ? (
                              <button
                                className={css(styles.avatarAction)}
                                onClick={this.avatarSaveImage}>
                                Save Photo
                              </button>
                            ) : false
                          }
                        </div>
                      </div>
                    </Modal>
                  ) : false
                }
              </div>
              {
                this.state.profile_photo ? (
                  <div className={css(styles.image_info_container)}>
                    <div className={css(styles.file_image)}>
                      <img
                        alt="Profile"
                        className={css(styles.profile_photo)}
                        src={this.state.profile_photo} />
                    </div>
                    <div className={css(styles.file_info)}>
                      <div className={css(styles.file_name)}>
                        {this.state.profile_photo_file}
                      </div>
                      <div className={css(styles.file_size)}>
                        {this.state.profile_photo_updated ?
                          this.fileSize(this.state.profile_photo_size) :
                          this.state.profile_photo_size}
                      </div>
                      <div
                        onClick={this.clearImage}
                        className={css(styles.clear_image)}
                        role="link"
                        tabIndex={0}>
                        Remove picture
                      </div>
                    </div>
                  </div>
                ) :
                  (
                    <Dropzone
                      maxSize={2097152}
                      multiple={false}
                      accept="image/jpeg, image/png, image/bmp"
                      onDrop={this.editAvator}
                      className={css(styles.dropzone)}>
                      <Isvg
                        cacheGetRequests
                        src={UPLOAD_ASSET}
                        className={css(styles.dropzone_icon)}
                      />
                      <p>
                        Drop files to attach or
                      <span className={css(styles.dropzone_browse, styles.highlight)}> browse</span>
                      </p>
                    </Dropzone>
                  )
              }
              {this.state.errors.photos ?
                <ErrorContainer message={this.state.errors.photos} />
                : null}
              {this.state.errors.profile_photo_error ?
                <ErrorContainer message={this.state.errors.profile_photo_error} />
                : null}
              <HorizontalRule />
              <div className={css(styles.actions)}>
                <button
                  className={css(styles.draft)}
                  onClick={this.saveDraft}>
                  Save as Draft
                </button>
                <button
                  className={css(styles.publish)}
                  onClick={this.savePublish}>
                  Save As Complete
                </button>
                <Tooltip
                  position="bottom"
                  arrow
                  html={(
                    <div className={css(styles.actions_tooltip)}>
                      Your borrower / owner profile remains private, until you request to share
                      a dog (borrower version) / accept a dog share request (owner version)
                    </div>
                  )}
                >
                  <Isvg
                    cacheGetRequests
                    src={TOOLTIP_ASSET}
                    className={css(styles.actions_tooltip_trigger)}
                  />
                </Tooltip>
              </div>
              <div className={css(styles.publishErrorWrapper)}>
                {this.state.errors.publishError ?
                  <ErrorContainer message={this.state.errors.publishError} />
                  : null}
              </div>
            </div>
          </div>
        </ContentContainer>
      </div>
    );
  }
}

EditProfile.propTypes = {
  appdata: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const styles = StyleSheet.create({
  actions_tooltip: {
    padding: 5,
    fontSize: 14,
    fontFamily: Theme.font_family_primary,
  },
  actions_tooltip_trigger: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 10px',
    cursor: 'pointer',
  },
  check_buttons: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -4.5px',

    [Theme.mobile_query]: {
      margin: 0,
    },
  },
  highlight: {
    color: Theme.primary,
  },
  checkboxes: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: 30,

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  dropzone: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 94,
    width: '100%',
    fontFamily: Theme.font_family_primary,
    backgroundColor: '#f2f2f2',
    border: '1px dashed #39b4d6',
    cursor: 'pointer',
  },
  dropzone_icon: {
    display: 'block',
    marginRight: 15,
  },
  dropzone_browse: {
    fontWeight: 900,
  },
  icon: {
    display: 'block',
    width: 159,
    margin: '0 auto 20px',
  },
  container: {
    padding: `86px 0 ${Theme.footer.height}px`,
    transition: 'transform 500ms',
    transform: 'translateX(100vw)',
  },
  select_parent_container: {
    position: 'relative',
    padding: '0px 5px',
    marginBottom: '5px',
    width: '50%',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  select_container: {
    position: 'relative',
    zIndex: 10,
    width: '100%',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  select_style: {
    width: '100%',
    height: '48px',
    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  container_active: {
    transform: 'translateX(0)',
  },
  container_completed: {
    transform: 'translateX(-100vw)',
  },
  main: {
    width: 750,
    margin: '0 auto',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  heading: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  sub_heading: {
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
    fontWeight: 500,
    fontSize: 20,
    color: '#000e1f',
  },
  paragraph: {
    width: '100%',
    padding: '0 5px',
    marginTop: -15,
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
    color: '#828282',
    lineHeight: 1.4,
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    width: 750,
    margin: '0 -5px',

    [Theme.mobile_query]: {
      width: '100%',
      margin: 0,
    },
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  draft: {
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: '#39b4d6',
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: Theme.white,
    cursor: 'pointer',
    outline: 'none',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  publish: {
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  publishErrorWrapper: {
    marginTop: 5,
    width: '100%',
  },
  profile_photo: {
    maxWidth: 150,
    maxHeight: 150,
    objectFit: 'contain',
  },
  image_info_container: {
    display: 'flex',
    flexDirection: 'row',
  },
  file_image: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  file_info: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 25,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  file_name: {
    marginBottom: 5,
  },
  file_size: {
    fontWeight: 'light',
    color: Theme.dark_grey,
  },
  clear_image: {
    marginTop: 10,
    cursor: 'pointer',
    color: Theme.teal,
    fontWeight: 'bold',
  },
  avatarEditor: {
    width: '100%',
    padding: 50,
  },
  avatarCanvas: {
    display: 'flex',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: Theme.baby_blue,
    borderStyle: 'dashed',
  },
  [Theme.desktop_query]: {
    body: {
      padding: 5,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
  },
  modal_container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    minHeight: 0,
    maxHeight: '100vh',
    backgroundColor: Theme.white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',
    [Theme.mobile_query]: {
      width: 'calc(100% - 30px)',
      minHeight: '0',
      maxHeight: 'none',
      height: 'auto',
    },
  },
  modal_wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 100px',
    [Theme.mobile_query]: {
      padding: '0px 20px 180px',
    },
  },
  actions_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    [Theme.mobile_query]: {
      flexWrap: 'wrap',
    },
  },
  rotate_icon: {
    width: 35,
    marginTop: 10,
    marginRight: 25,
  },
  modal_title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 24,
    fontWeight: '600',
    textAlign: 'center',
    padding: 25,
  },
  avatarAction: {
    width: 200,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none',
    [Theme.mobile_query]: {
      width: '100%',
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditProfile);



// WEBPACK FOOTER //
// ./src/views/EditProfile/index.js